<div>
  <span
    *ngIf="show"
    #spinner
    class="wf-spinner"
    (dblclick)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
  ></span>
</div>
